// CSS alleen in de client bundle - SSR (Node.js) kan geen .css importeren
import './styles/tailwind.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import { createApp } from './main.js'

const { app, router, pinia } = createApp()

// Vang Vue-renderfouten op zodat ze zichtbaar blijven in de console.
app.config.errorHandler = (err, _instance, info) => {
  console.error('[P2C] Vue render fout:', info, err)
}

// Vang router-fouten op (bijv. mislukte dynamische import van een pagina-chunk)
router.onError((err) => {
  console.error('[P2C] Router fout:', err)
})

// Herstel Pinia state van SSR - standaard Pinia SSR aanpak
if (window.__INITIAL_STATE__) {
  pinia.state.value = window.__INITIAL_STATE__
}

router.isReady().then(() => {
  // ── Forceer schone client-render in plaats van SSR-hydration ──────────────
  // De hydration-flow in Vue 3 + vue-router verwijdert het #app container-element
  // uit de DOM op productpagina's (hydration mismatch → Vue patcht met verkeerde
  // DOM-referentie → container raakt gedetached). Door de container te legen
  // vóór app.mount() ziet Vue hasChildNodes() === false en doet Vue een schone
  // client-render in plaats van hydration. Dit is stabiel en identiek aan een
  // normale SPA-render - er is geen zichtbare flash omdat het leegmaken en
  // het renderen in dezelfde JS-taak plaatsvinden.
  const container = document.getElementById('app')
  if (container) {
    container.innerHTML = ''
  }

  app.mount('#app')

  // Stuur de eerste page_view na mount
  // (router.afterEach vuurt niet bij de initiële SSR-render)
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path:  window.location.pathname + window.location.search,
      page_title: document.title,
    })
  }
}).catch((err) => {
  console.error('[P2C] router.isReady() rejected:', err)
})
